import { unFormatCurrency, toFixed } from 'utils';
import { unFormatCurrencyNumber } from 'utils/currency';

export const existingPolicy = (values: any) => {
  if (!values) return {};
  const errors: any = {
    settings: {
      funds: {
        errors: null
      }
    }
  };

  const { fund_value, fund_allocations } = values;
  const areFundsAllocated = fund_allocations && fund_allocations.length > 0;

  const hasZeroFunds =
    areFundsAllocated &&
    fund_allocations.some((fund: any) => {
      const fundAmount = fund.fund_value
        ? unFormatCurrencyNumber(fund.fund_value)
        : 0;
      return fundAmount === 0 || isNaN(fundAmount);
    });

  if (hasZeroFunds) {
    errors.settings.funds.errors =
      'Some funds have a value of £0.00 and will be lost if you proceed. Please review.';
    return errors;
  }

  // Sum all allocated fund values
  const sumFundAllocations =
    fund_allocations &&
    fund_allocations.reduce(
      (a: any, b: any) => {
        const fundA = a.fund_value ? unFormatCurrency(a.fund_value) : 0;
        const fundB = b.fund_value ? unFormatCurrency(b.fund_value) : 0;
        return {
          fund_value: toFixed(fundA) + toFixed(fundB)
        };
      },
      { fund_value: 0 }
    );

  if (areFundsAllocated) {
    if (
      toFixed(sumFundAllocations.fund_value) !==
      toFixed(Number(unFormatCurrency(fund_value)))
    ) {
      errors.settings.funds.errors =
        'Funds allocations are not equal to Funds value';
    }
  }

  return errors;
};
